module.exports = __webpack_public_path__ + "img/pipeline_fr.1d42faab.jpg";